import { render, staticRenderFns } from "./share_button.vue?vue&type=template&id=56f1263b&scoped=true&"
import script from "./share_button.vue?vue&type=script&lang=js&"
export * from "./share_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f1263b",
  null
  
)

export default component.exports